<template>
  <div>
    <custom-callout
      :border-color="'gray'"
      class-main="mt-3 rounded"
      :has-toggle="false"
      :opened="false"
    >
      <div class="row py-2 mr-md-0 align-items-center mobile-only">
        <div class="col-12 col-md-1 text-center mr-n5">
          <div class="col-12 mb-4">
            <div
              class="
                d-flex
                flex-column
                font-weight-bold
                color-black
                mt-n5
                ml-n4
                mt-sm-n5
                ml-sm-n4
              "
            >
              <div class="dot text-center color-white">
                <i class="fas fa-map-marker-alt" />
              </div>
            </div>
          </div>
          <div class="col-12" />
        </div>
        <div class="col col-md-5 col-sm-12">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">
              Dirección {{ data.addressTypeDescription | empty }}:
            </div>
            <div class="color-black font-16">
              {{ fullAddress }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Información Adicional:</div>
            <div class="color-black font-16">
              {{ data.additionalAnnotations | empty }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">Latitud:</div>
            <div class="color-black font-16">
              {{ data.latitude | empty }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div class="col-lg mb-4">
            <div class="color-gray-6 font-14">Longitud:</div>
            <div class="color-black font-16">
              {{ data.longitude | empty }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div class="mb-5 d-flex justify-content-end">
            <drop-down :items="actionItems" />
          </div>
        </div>
      </div>
    </custom-callout>
    <slot :addressObj="data" />
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import AddressTypes from '@/utils/constants/addressTypes.js';

export default {
  name: 'AddressResultRow',
  components: {
    CustomCallout,
    DropDown,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
  computed: {
    isPhysicalAddress() {
      return this.data?.addressTypeCd === AddressTypes.Physical;
    },
    fullAddress() {
      const address = `${this.data.addressLine1 || ''} ${this.data
        .addressLine2 || ''} ${this.data.addressLine3 || ''} ${this.data
        .municipalityDescription || ''}`.trim();
      return `${address}, Puerto Rico ${this.data.zipCode}`;
    },
    actionItems() {
      return [
        {
          label: 'Editar',
          icon: 'fas fa-edit color-green',
          border: this.isPhysicalAddress ? '' : 'bottom',
          click: () => this.$emit('on-edit-address'),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red',
          visible: !this.isPhysicalAddress,
          click: () => this.$emit('on-delete-address'),
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.dot {
  background-color: map-get($colors, 'orange');
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
}

@media screen and (max-width: 768px) {
  .mobile-only {
    display: block;
  }
  .mt-sm-n5 {
    margin-top: 0 !important;
  }
  .ml-sm-n4 {
    margin-left: 0 !important;
  }
}
</style>
